import React, { createContext, useContext, useRef, useState, useEffect } from "react";
import { AudioContextProps, AudioProviderProps } from "../audio.types";
import { useBookContext } from "../../../../context/book/book-context";

export const AudioContext = createContext(null);

export const AudioProvider = ({ children }) => {
  const audioRef = useRef(null);
  const [isPlaying, setIsPlaying] = useState(false);
  const { book, setCurrentChapter, currentChapter, setLoadingChunk } =
    useBookContext();
  // const currentChapterIndex = book.chapters.indexOf(currentChapter);
  const [currentChapterIndex, setCurrentChapterIndex] = useState([]);
  useEffect(() => {
    setCurrentChapterIndex(book && book.chapters && book.chapters.indexOf(currentChapter));
  }, [book]);
  useEffect(() => {
    setCurrentChapterIndex(book && book.chapters && book.chapters.indexOf(currentChapter));
  }, [currentChapter]);
  const [progressChaptersGroup, setProgressChaptersGroup] = useState(
    {}
  );
  const [audioPreferences, setAudioPreferences] = useState({
    speed: 1,
    volume: 1,
  });

  const currentChapterProgress =
    progressChaptersGroup[(currentChapter && currentChapter.uid) || ""] || 0;

  const handlePlayPause = (forcePlay) => {
    if (audioRef.current) {
      if (isPlaying && !forcePlay) {
        audioRef.current.pause();
      } else {
        audioRef.current.play();
      }
      setIsPlaying(forcePlay ? true : !isPlaying);
    }
  };

  const updateProgressChapterGroup = (
    newProgress,
    chapterId
  ) => {
    setProgressChaptersGroup((prev) => ({
      ...prev,
      [chapterId || currentChapter.uid || ""]: newProgress,
    }));
  };

  const handleTimeUpdate = () => {
    if (audioRef.current) {
      const { currentTime, duration } = audioRef.current;
      if (!currentTime || !duration) {
        return;
      }
      updateProgressChapterGroup((currentTime / duration) * 100);
    }
  };

  const handleProgressChange = (e) => {
    const { value } = e.target;
    if (audioRef.current) {
      audioRef.current.currentTime =
        (audioRef.current.duration / 100) * Number(value);
      updateProgressChapterGroup(Number(value));
    }
  };

  const handleProgressReset = (newProgress, nextPrevId) => {
    if (audioRef.current) {
      if (typeof audioRef.current.duration !== "number") {
        audioRef.current.currentTime = 0;
      } else {
        let time = audioRef.current.duration / 100;
        if (isNaN(time)) time = 0;

        audioRef.current.currentTime = time * Number(newProgress);
      }

      updateProgressChapterGroup(Number(newProgress), nextPrevId);
    }
  };

  const handleSkip = (seconds) => {
    if (audioRef.current) {
      audioRef.current.currentTime = Math.min(
        audioRef.current.duration,
        Math.max(0, audioRef.current.currentTime + seconds)
      );
    }
  };

  const handleNextPrevious = (action) => {
    if (audioRef.current) {
      const index =
        action === "next" ? currentChapterIndex + 1 : currentChapterIndex - 1;
      const chapter = book.chapters[index];
      // if(!chapter) {
      //   handlePlayPause(false);
      //   setLoadingChunk(false);
      //   setCurrentChapter(book.chapters[0]);
      //   return;
      // }
      // const newProgress = progressChaptersGroup[chapter.uid || ""] || 0;
      // handlePlayPause(true);

      // setCurrentChapterIndex(book.chapters.indexOf(chapter));
      if (chapter) {
        setCurrentChapter(chapter);
        const newProgress = progressChaptersGroup[chapter.uid || ""] || 0;
        setLoadingChunk(true);

        setTimeout(() => {
          handleProgressReset(newProgress, chapter.uid || "");
        }, 500);

        setTimeout(() => {
          handlePlayPause(true);
        }, 1000);
      }
    }
  };

  const handleVolumeChange = (e) => {
    const newVolume = Number(e.target.value);
    setAudioPreferences((prev) => ({ ...prev, volume: newVolume }));
    if (audioRef.current) {
      audioRef.current.volume = newVolume;
    }
  };

  const handleSpeedChange = (e) => {
    const newSpeed = Number(e.target.value);
    setAudioPreferences((prev) => ({ ...prev, speed: newSpeed }));
    if (audioRef.current) {
      audioRef.current.playbackRate = newSpeed;
    }
  };

  return (
    <AudioContext.Provider
      value={{
        audioRef,
        handlePlayPause,
        handleProgressChange,
        handleNextPrevious,
        handleSkip,
        handleTimeUpdate,
        handleSpeedChange,
        handleVolumeChange,
        isPlaying,
        progress: currentChapterProgress,
        progressChaptersGroup,
        audioPreferences,
      }}
    >
      {children}
    </AudioContext.Provider>
  );
};

export const useAudio = () => useContext(AudioContext);
